export const colors = ['#b391ea', '#69a2f3', '#6fbad6', '#91a6ea', '#ea8888', '#7bdd92', '#e3b47d', '#ff7777'];

const fileUploadSubMenu = [
	{ key: 'batch-upload', value: 'Batch Upload' },
	{ key: 'batch-integration-maintenance', value: 'Batch Integration' }
];

export const sidebarMenu = [
	{ key: 'dashboard', value: 'Dashboard' },
	{ key: 'transaction-table', value: 'Transaction Table' },
	{ key: 'payment-plan', value: 'Payment Plan Table' },
	{ key: 'callback-request', value: 'Callback Request Table' },
	{ key: 'communication-templates', value: 'Templates' },
	{ key: 'workflow', value: 'Workflow' },
	{ key: 'customer-file-upload', value: 'Customer File Details', submenu: fileUploadSubMenu },
	{ key: 'user-management', value: 'User Management' }
];

export const adminSidebarMenu = [
	{ key: 'invoice-slab-maintenance', value: 'Invoice Slab Maintenance' },
	{ key: 'generate-invoice', value: 'Generate Invoice' }
];

export const BIMTabList = [
	{ id: '', key: 'bfm_linkageCount', value: 'Top Used', type: 'tab', filter: false },
	{ id: '', key: 'updatedAt', value: 'Recently Used', type: 'tab', filter: false },
	{ id: 'bfm_fileType', key: 'excel', value: 'Excel', type: 'tab', filter: true },
	{ id: 'bfm_fileType', key: 'delimiter', value: 'Delimiter Seperated', type: 'tab', filter: true }
];

export const conditionSearchList = [
	{ id: 'bfm_loadCode', key: 'bfm_loadCode', value: 'Name' },
	{ id: 'bfm_description', key: 'bfm_description', value: 'Description' },
	{ id: 'bfm_fileType', key: 'bfm_fileType', value: 'File Type' },
	{ id: 'bfm_product', key: 'bfm_product', value: 'Product' },
	{ id: 'bfm_version', key: 'bfm_version', value: 'Version' }
];

export const dockerlist = ['edit', 'delete', 'view'];
export const editDockerlist = ['edit', 'view'];
export const workflowDockerlist = ['edit', 'delete', 'view', 'trigger'];

export const BIMSectionList = [
	{ key: 'general_details', value: 'General Details' },
	{ key: 'upload_data', value: 'Upload Data' },
	{ key: 'linkage', value: 'Linkage' },
	{ key: 'alert_messages', value: 'Alert Messages' }
];

export const TemplatesSection = [
	{ key: 'general_details', value: 'General Details' },
	{ key: 'template_configuration', value: 'Template Configuration' }
];

export const bimFileType = [
	{ key: 'delimiter_separated', value: 'Delimiter Seperated' },
	{ key: 'excel', value: 'Excel' }
];

export const validators = {
	bimAdd: ['bfm_loadCode', 'bfm_description', 'bfm_fileType', 'bfm_linkages', 'bfm_dateFormat', 'bfm_fileName'],
	uploadFile: ['bfm_loadCode', 'file'],
	onboardingSignup: ['c_workEmail', 'c_name', 'c_country', 'c_password', 'c_rePassword', 'c_mobileNumber', 'c_username'],
	userManagement: ['first_name', 'last_name', 'country', 'mobile', 'email', 'user_name', 'password', 'rePassword'],
	userManagementEdit: ['first_name', 'last_name', 'country', 'mobile', 'email', 'user_name']
};

export const bimUploadTableHeaders = [
	{ key: 'bfm_serialNumber', value: 'S.No' },
	{ key: 'bfm_fieldPosition', value: 'Field Position ' },
	{ key: 'bfm_columnHeading', value: 'Field Label' },
	{ key: 'bfm_desField', value: 'Destination Field' },
	{ key: 'bfm_refLink', value: 'Linkage Reference' },
	{ key: 'bfm_linkedSNo', value: 'Linked Position' },
	{ key: 'bfm_formula', value: 'Formula' }
];

export const profileSectionList = [
	{ key: 'basic_details', value: 'Basic Details' },
	{ key: 'company_details', value: 'Company Details' },
	{ key: 'payment_details', value: 'Payment Details' },
	{ key: 'channel_configuration', value: 'Channel Configuration' }
];

export const alertMailConfig = [
	{ key: 'mailIdsForSucc', value: 'If Its Successful' },
	{ key: 'mailIdsForFail', value: 'If Its UnSuccessful' }
];

export const defaultRoutes = ['onboarding', 'faq', '', 'verify', 'tutorial'];

export const newFactlist = {
	fa_example: '',
	fa_name: '',
	fg_isDisabled: 'N',
	fa_collection: '',
	fa_actualDataType: '',
	fa_description: '',
	fa_isFilterAllowed: 'N',
	fa_isSortAllowed: 'Y',
	fa_formula_type: 'DIRECT'
};

export const BIMCreateObj = {
	bfm_loadCode: '',
	bfm_description: '',
	bfm_fileType: '',
	bfm_status: '',
	bfm_fileName: '',
	bfm_associatedHierarchy: '',
	bfm_fieldDelimiter: '',
	bfm_dateFormat: '',
	bfm_skipFooter: 'N',
	bfm_skipHeader: 'N',
	bfm_uploadDetails: [],
	bfm_linkages: [{ p_code: '', bfm_filePath: '' }],
	bfm_alerts: {},
	bfm_fileObj: {}
};

export const contactUsInfoList = [
	{ name: 'Email', key: 'email', image: 'email' },
	{ name: 'Phone Number', key: 'phoneNumber', image: 'call' },
	{ name: 'Address', key: 'address', image: 'location' }
];

export const helpList = [
	{ key: 'faq', name: 'FAQ' },
	{ key: 'contactus', name: 'Contact Us' },
	{ key: 'chatbot', name: 'Chatbot' },
	{ key: 'tutorial', name: 'Tutorial' }
];

export const menuList = [
	{ key: 'my-profile', value: 'My Profile' },
	// { key: 'team-members', value: 'Team Members' },
	// { key: 'roles', value: 'Roles & Permissions' },
	// { key: 'help-menu', value: 'Help' },
	{ key: 'logout', value: 'Log Out' }
];

export const incrementalLoadList = [
	{ key: 'incremental_load', value: 'Incremental Load' },
	{ key: 'fresh_load', value: 'Fresh Load' }
];

export const analyticsActionsList = [
	{ key: 'total_visit', mapping: 'totalVisited' },
	{ key: 'callback_requested', mapping: 'totalVisited' },
	{ key: 'payment_plan', mapping: 'totalVisited' },
	{ key: 'paynow', mapping: 'totalVisited' }
];

export const doughnutConfig = {
	responsive: true,
	maintainAspectRatio: false,
	cutout: 70,
	plugins: {
		legend: {
			position: 'right',
			align: 'middle',
			labels: {
				boxHeight: 8,
				boxWidth: 25,
				color: '#000000'
			}
		}
	}
};

export const horizontalBarDelivered = {
	indexAxis: 'y',
	responsive: true,
	maintainAspectRatio: false,
	plugins: { legend: { display: false } },
	scales: {
		y: {
			display: false,
			ticks: {
				display: false
			}
		},
		x: {
			title: { display: true, text: 'Counts ➝', font: { size: 14 } },
			ticks: {
				beginAtZero: true,
				callback: value => {
					if (value % 1 === 0) {
						return value;
					}
				}
			}
		}
	}
};

export const channelStatisticsAnalytics = {
	responsive: true,
	maintainAspectRatio: false,
	plugins: { legend: { display: false } },
	scales: {
		y: {
			ticks: {
				beginAtZero: true,
				callback: value => {
					if (value % 1 === 0) {
						return value;
					}
				}
			},
			title: { display: true, text: 'Counts ➝', font: { size: 14, color: 'red' } }
		},
		x: {
			grid: { display: false },
			title: { display: true, text: 'Channels ➝', font: { size: 14 } }
		}
	}
};

export const actionStatisticsAnalytics = {
	responsive: true,
	maintainAspectRatio: false,
	plugins: {
		legend: { display: false }
	},
	scales: {
		x: {
			stacked: true,
			grid: { display: false },
			title: { display: true, text: 'Channels ➝', font: { size: 14 } }
		},
		y: {
			stacked: true,
			ticks: {
				beginAtZero: true,
				callback: value => {
					if (value % 1 === 0) {
						return value;
					}
				}
			}
		}
	}
};

export const analyticsColors = ['#9e7bff', '#36a2eb', '#4bc0c0'];

export const workflowConfigNodes = [
	{
		key: 'header',
		nextNode: ['action'],
		sidebarHeader: 'Components',
		sidebarWidth: 350,
		currentStage: 'components'
	},
	{
		key: 'action',
		nextNode: ['delay'],
		sidebarHeader: 'Action',
		sidebarWidth: 350,
		currentStage: 'components'
	},
	{
		key: 'delay',
		nextNode: ['action', 'decision'],
		sidebarHeader: 'Delay',
		sidebarWidth: 350,
		currentStage: 'components'
	},
	{
		key: 'decision',
		nextNode: ['action'],
		sidebarHeader: 'Decision',
		sidebarWidth: 350,
		currentStage: 'components'
	},
	{
		key: 'linkConfiguration',
		nextNode: [],
		sidebarHeader: 'Link configuration',
		sidebarWidth: 650,
		currentStage: 'linkConfiguration'
	},
	{
		key: 'entryCondition',
		nextNode: [],
		sidebarHeader: 'Entry Conditions',
		sidebarWidth: 350,
		currentStage: 'entryCondition'
	},
	{
		key: 'exitCondition',
		nextNode: [],
		sidebarHeader: 'Exit Conditions',
		sidebarWidth: 350,
		currentStage: 'exitCondition'
	},
	{
		key: 'addCondition',
		nextNode: [],
		sidebarHeader: 'Add Condition',
		sidebarWidth: 1200,
		currentStage: 'addCondition'
	},
	{
		key: 'editCondition',
		nextNode: [],
		sidebarHeader: 'Edit Condition',
		sidebarWidth: 1200,
		currentStage: 'editCondition'
	}
];

export const workflowComponentList = [
	{ key: 'action', value: 'Action' },
	{ key: 'delay', value: 'Delay' },
	{ key: 'decision', value: 'Decision' }
];

export const workflowInitialNode = {
	id: '0',
	type: 'header',
	data: {
		title: '',
		type: 'header',
		description: '',
		position: { x: 0, y: 0 }
	},
	position: { x: 0, y: 0 }
};

export const newRule = { all: [] };

export const operatorList = [
	{
		type: 'default',
		operator: ['Equal', 'Not equal', 'Less than', 'Less than or equal', 'Greater than', 'Greater than or equal', 'Does not contain', 'Contains', 'Not in', 'In'],
		placeholder: 'Value'
	}
];

export const apiOp = [
	{
		op_key: 'equal',
		op_name: 'Equal',
		op_type: ['string', 'numeric'],
		op_description: 'fact must equal value'
	},
	{
		op_key: 'notEqual',
		op_name: 'Not equal',
		op_type: ['string', 'numeric'],
		op_description: 'fact must not equal value'
	},
	{
		op_key: 'lessThan',
		op_name: 'Less than',
		op_type: ['numeric'],
		op_description: 'fact must be less than value'
	},
	{
		op_key: 'lessThanInclusive',
		op_name: 'Less than or equal',
		op_type: ['numeric'],
		op_description: 'fact must be less than or equal to value'
	},
	{
		op_key: 'greaterThan',
		op_name: 'Greater than',
		op_type: ['numeric'],
		op_description: ' fact must be greater than value'
	},
	{
		op_key: 'greaterThanInclusive',
		op_name: 'Greater than or equal',
		op_type: ['numeric'],
		op_description: 'fact must be greater than or equal to value'
	},
	{
		op_key: 'in',
		op_name: 'In',
		op_type: ['array'],
		op_description: ''
	},
	{
		op_key: 'notIn',
		op_name: 'Not in',
		op_type: ['array'],
		op_description: ''
	},
	{
		op_key: 'contains',
		op_name: 'Contains',
		op_type: ['array'],
		op_description: ''
	},
	{
		op_key: 'doesNotContain',
		op_name: 'Does not contain',
		op_type: ['array'],
		op_description: ''
	}
];

export const conditionWorkflow = [
	{ key: 'entryCondition', value: 'Entry Condition', infoContent: 'If condition matches Accounts will enter into the workflow' },
	{ key: 'exitCondition', value: 'Exit Condition', infoContent: 'If condition matches Accounts will exit from the workflow' }
];

export const tablist = [
	{ key: 'Facts', value: 'Facts', infoContent: 'Facts are used to define rules for the conditions' },
	{ key: 'Expression', value: 'Expression', infoContent: 'Expression are used to define custom facts' },
];

export const linkConfigurationStructure = {
	featureList: [],
	activeTill: '',
	paynowConfiguration: {
		allowEdit: false,
		minimumAmount: '',
		maximumAmount: '',
		termsAndConditionsTemplate: [],
		paymentGateways: []
	},
	paymentPlanConfiguration: {
		captureReason: false,
		maximumCharLimit: '',
		paymentFrequency: [],
		termsAndConditionsTemplate: [],
		deleteExistingPlan: ''
	},
	callbackLaterConfiguration: {
		captureReason: false,
		maximumCharLimit: '',
		timeslots: []
	}
};

export const linkConfigurationKeys = [
	{ key: 'PAY_NOW', value: 'paynowConfiguration' },
	{ key: 'PAYMENT_PLAN', value: 'paymentPlanConfiguration' },
	{ key: 'CALLBACK_LATER', value: 'callbackLaterConfiguration' }
];

export const slabTableHeaders = [
	{ field_key: 'featureList', label: 'Features Utilised' },
	{ field_key: 'amount', label: 'Amount' }
];

export const generateInvoiceHeaders = [
	{ columnWidth: 200, field_key: 'c_name', label: 'Client Name' },
	{ columnWidth: 200, field_key: 'c_invoiceNumber', label: 'Invoice Number' },
	{ columnWidth: 200, field_key: 'durationStart', label: 'Invoice Start Date' },
	{ columnWidth: 200, field_key: 'durationEnd', label: 'Invoice End Date' },
	{ columnWidth: 200, field_key: 'createdAt', label: 'Invoice Sent Date' },
	{ columnWidth: 200, field_key: 'c_currencyCode', label: 'Currency Code' },
	{ columnWidth: 200, field_key: 'c_invoiceAmount', label: 'Invoice Amount' }
];

export const currency_symbols = { USD: '$', AUD: '$', EUR: '€', CRC: '₡', GBP: '£', ILS: '₪', INR: '₹', JPY: '¥', KRW: '₩', NGN: '₦', PHP: '₱', PLN: 'zł', PYG: '₲', THB: '฿', UAH: '₴', VND: '₫' };
